<template>
    <div class="text-xs-center">
        <v-container fluid fill-height :dark="false" align-center justify-center>
            <v-btn color="#4286f5" dark @click="loginWithGoogle()" x-large class="login-with-google">
                <v-avatar tile size="50" class="white mr-3" style="border-radius: 3px;">
                    <img class="pa-2" src="@/assets/google-icon.png" alt="Image" />
                </v-avatar>
                <h2 class="login-with-google-text">{{ $t('screener.login_with_google.title') }}</h2>
            </v-btn>
      </v-container>
    </div>
</template>
<script>
import * as firebase from "firebase";
export default {
    name: 'SocialLogin',
    methods: {
        async loginWithGoogle(){
            const provider = new firebase.auth.GoogleAuthProvider()
            firebase.auth().signInWithPopup(provider).
            then(async (response) => {
                this.$emit('onSuccess',response)
            })
            .catch((error) => {
                 console.error('Google authentication failed',error)
            })
        },
    }
}
</script>
<style scoped>
.login-with-google{
    height: 60px;
    padding-left: 6px;
}
.login-with-google-text{
   text-transform: initial;
   letter-spacing: 0.03em; 
}
</style>
